module.exports = __webpack_public_path__ + "static/media/ios.efb534f3.svg";